import React, { useState, useEffect } from "react";
import styles from "../commanstyles.module.css";
import { FaMinusSquare, FaPlusSquare } from "react-icons/fa";
import { IoMdLock } from "react-icons/io";
import { IoDocumentTextOutline } from "react-icons/io5";
import { FiDownload } from "react-icons/fi";

function PrincipalBusinessActivities({ isSubScribe, data }) {
    const [currentPage, setCurrentPage] = useState(1);
    const [isTableOpen, setIsTableOpen] = useState(true);
    const [selectedYear, setSelectedYear] = useState(""); // Track selected year
    const [filteredData, setFilteredData] = useState(data); // State to hold filtered data
    const rowsPerPage = 10;

    const totalPages = Math.ceil(filteredData.length / rowsPerPage);

    // Update filteredData when data or selectedYear changes
    useEffect(() => {
        // Sort data by financial year (descending order)
        const sortedData = [...data].sort(
            (a, b) => b.financialYear - a.financialYear
        );

        // Set the most recent year as default if no year is selected
        if (!selectedYear && sortedData.length > 0) {
            setSelectedYear(sortedData[0].financialYear);
        }

        const updatedFilteredData = selectedYear
            ? sortedData.filter((item) => item.financialYear === selectedYear)
            : sortedData;

        setFilteredData(updatedFilteredData);
        setCurrentPage(1); // Reset to first page when filter changes
    }, [selectedYear, data]); // Trigger when selectedYear or data changes

    const handleClick = (page) => {
        setCurrentPage(page);
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentData = filteredData.slice(indexOfFirstRow, indexOfLastRow);

    const toggleTable = () => {
        setIsTableOpen(!isTableOpen);
    };

    const handleYearChange = (e) => {
        setSelectedYear(e.target.value);
    };

    return (
        <div className={styles.table_subcontainer}>
            <div>
                {isSubScribe && (
                    <div className={styles.highlet_header_content1}>
                        <p className={styles.minuse_icon} onClick={toggleTable}>
                            {isTableOpen ? (
                                <FaMinusSquare size={22} />
                            ) : (
                                <FaPlusSquare size={22} />
                            )}
                        </p>
                        {/* <h3 className={styles.highlet_text}>
              PRINCIPAL BUSINESS ACTIVITIES- 31 Mar,{" "}
              {currentData.length > 0 ? currentData[0].financialYear : "-"}
            </h3> */}
                        <h3 className={styles.highlet_text}>
                            Principal Business Activites
                            {currentData.length > 0 && (
                                <> - 31 Mar, {currentData[0].financialYear}</>
                            )}
                        </h3>

                        {/* Financial Year Dropdown */}
                        {data.length > 0 && (
                            <div className={styles.yearSelectContainer}>
                                <select
                                    id="financialYear"
                                    value={selectedYear}
                                    onChange={handleYearChange}>
                                    <option value="" disabled>
                                        Select Years
                                    </option>
                                    {/* Dynamically add unique years from the data */}
                                    {[
                                        ...new Set(
                                            data.map(
                                                (item) => item.financialYear
                                            )
                                        ),
                                    ].map((year) => (
                                        <option key={year} value={year}>
                                            {parseInt(year) - 1} - {year}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}
                    </div>
                )}

                {/* Reference Documents Section */}
                {isSubScribe && (
                    <div>
                        {filteredData && filteredData[0] && (
                            <div className={styles.referencedoc_main}>
                                <div>
                                    <b>Reference Documents</b>
                                </div>

                                <div className={styles.referencedoc_container}>
                                    {filteredData[0]?.refDoc ? (
                                        <>
                                            <div>
                                                {filteredData[0]?.refDoc
                                                    ?.MaiinFileName && (
                                                    <a
                                                        href={
                                                            filteredData[0]
                                                                ?.refDoc
                                                                ?.fileurl
                                                        }
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className={
                                                            styles.referencedoc_mainfilename
                                                        }>
                                                        {
                                                            filteredData[0]
                                                                ?.refDoc
                                                                ?.MaiinFileName
                                                        }
                                                    </a>
                                                )}
                                                <ul style={{ padding: 0 }}>
                                                    {filteredData[0]?.refDoc
                                                        ?.Attachments &&
                                                    filteredData[0]?.refDoc
                                                        ?.Attachments.length >
                                                        0 ? (
                                                        filteredData[0]?.refDoc?.Attachments.map(
                                                            (
                                                                attachment,
                                                                index
                                                            ) => (
                                                                <li
                                                                    key={index}
                                                                    className={
                                                                        styles.referencedoc_Attachments
                                                                    }>
                                                                    <IoDocumentTextOutline
                                                                        size={
                                                                            16
                                                                        }
                                                                        style={{
                                                                            marginRight:
                                                                                "8px",
                                                                            color: "#2961EF",
                                                                        }}
                                                                    />
                                                                    <a
                                                                        href={
                                                                            attachment.fileurl
                                                                        }
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        style={{
                                                                            textDecoration:
                                                                                "none",
                                                                            color: "#2961EF",
                                                                        }}>
                                                                        {
                                                                            attachment.Name
                                                                        }
                                                                    </a>
                                                                    <button
                                                                        onClick={() => {
                                                                            const link =
                                                                                document.createElement(
                                                                                    "a"
                                                                                );
                                                                            link.href =
                                                                                attachment.fileurl;
                                                                            link.download =
                                                                                attachment.Name;
                                                                            link.click();
                                                                        }}
                                                                        title="Download"
                                                                        style={{
                                                                            background:
                                                                                "none",
                                                                            border: "none",
                                                                            cursor: "pointer",
                                                                            color: "#2961EF",
                                                                            marginLeft:
                                                                                "5px",
                                                                            textDecoration:
                                                                                "underline",
                                                                        }}>
                                                                        <FiDownload />
                                                                    </button>
                                                                </li>
                                                            )
                                                        )
                                                    ) : (
                                                        <span>
                                                            No attachments
                                                            available.
                                                        </span>
                                                    )}
                                                </ul>
                                            </div>
                                        </>
                                    ) : (
                                        <span>
                                            No documents available for selected
                                            year
                                        </span>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {isTableOpen && (
                    <>
                        {!isSubScribe && (
                            <button className={styles.Subscription_msg}>
                                <IoMdLock /> Subscription required to view data
                            </button>
                        )}

                        {isSubScribe && (
                            <table className={styles.commantable}>
                                <thead>
                                    <tr className={styles.tableHeaderRow}>
                                        <th className={styles.tableHeader}>
                                            SNo.
                                        </th>
                                        <th className={styles.tableHeader}>
                                            Main Activity Group Code
                                        </th>
                                        <th className={styles.tableHeader}>
                                            Description of Main Activity Group
                                        </th>
                                        <th className={styles.tableHeader}>
                                            Business Activity Code
                                        </th>
                                        <th className={styles.tableHeader}>
                                            Description Of Business Activity
                                        </th>
                                        <th className={styles.tableHeader}>
                                            % of turnover of the company
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentData.length > 0 ? (
                                        currentData.map((row, index) => (
                                            <tr
                                                key={row.Id}
                                                className={styles.tableRow}>
                                                <td
                                                    className={
                                                        styles.tableCell
                                                    }>
                                                    {indexOfFirstRow +
                                                        index +
                                                        1}
                                                    .
                                                </td>
                                                <td
                                                    className={
                                                        styles.tableCell
                                                    }>
                                                    {row.mainActivityGroupCode}
                                                </td>
                                                <td
                                                    className={
                                                        styles.tableCell
                                                    }>
                                                    {
                                                        row.mainActivity_description
                                                    }
                                                </td>
                                                <td
                                                    className={
                                                        styles.tableCell
                                                    }>
                                                    {row.businessActivityCode}
                                                </td>
                                                <td
                                                    className={
                                                        styles.tableCell
                                                    }>
                                                    {
                                                        row.businessActivity_description
                                                    }
                                                </td>
                                                <td
                                                    className={
                                                        styles.tableCell
                                                    }>
                                                    {row.turnover_percentage}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td
                                                colSpan="6"
                                                className={styles.noData} style={{textAlign:"center"}}>
                                                No Principal Business Activities available
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        )}

                        {isSubScribe && currentData.length > 0 && (
                            <div className={styles.pagination}>
                                <button
                                    onClick={handlePrevious}
                                    disabled={currentPage === 1}>
                                    &lt;
                                </button>
                                {[...Array(totalPages).keys()].map((num) => (
                                    <button
                                        key={num + 1}
                                        onClick={() => handleClick(num + 1)}
                                        className={
                                            currentPage === num + 1
                                                ? styles.active
                                                : ""
                                        }>
                                        {num + 1}
                                    </button>
                                ))}
                                <button
                                    onClick={handleNext}
                                    disabled={currentPage === totalPages}>
                                    &gt;
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}

export default PrincipalBusinessActivities;
